export const PARTNER_LOAD_REQUEST = 'PARTNER_LOAD_REQUEST';
export const PARTNER_LOAD_SUCCESS = 'PARTNER_LOAD_SUCCESS';
export const PARTNER_LOAD_FAILURE = 'PARTNER_LOAD_FAILURE';
